import { render, staticRenderFns } from "./TextFooter.vue?vue&type=template&id=412c26c3&scoped=true&"
import script from "./TextFooter.vue?vue&type=script&lang=js&"
export * from "./TextFooter.vue?vue&type=script&lang=js&"
import style0 from "./TextFooter.vue?vue&type=style&index=0&id=412c26c3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "412c26c3",
  null
  
)

export default component.exports